import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "payment-requests-top-up-modal__container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "container__title" }, "Пополнение баланса", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "container__description" }, "Общий баланс поставщика", -1)
const _hoisted_4 = { class: "container__current" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "current__label" }, "Текущий баланс:", -1)
const _hoisted_6 = { class: "current__value" }
const _hoisted_7 = { class: "container__check" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "check__label" }, "Чек о переводе *", -1)
const _hoisted_9 = { class: "container__actions" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M20 6 9 17l-5-5" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs_field = _resolveComponent("bs-field")!
  const _component_bs_file_zone = _resolveComponent("bs-file-zone")!
  const _component_bs_textarea = _resolveComponent("bs-textarea")!
  const _component_bs_button = _resolveComponent("bs-button")!
  const _component_bs_modal_scroll_container = _resolveComponent("bs-modal-scroll-container")!
  const _component_bs_modal = _resolveComponent("bs-modal")!

  return (_openBlock(), _createBlock(_component_bs_modal, {
    "model-value": _ctx.modelValue,
    "onUpdate:modelValue": _ctx.onUpdateModelValue,
    onClose: _ctx.onClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createVNode(_component_bs_modal_scroll_container, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.formatPriceToTenge(_ctx.balance, { withDecimals: true })), 1)
            ]),
            _createVNode(_component_bs_field, {
              placeholder: "Сумма пополнения",
              disabled: _ctx.state.isLoading,
              invalid: _ctx.state_form$.amount.$error,
              "validation-errors": _ctx.state_form$.amount.$errors,
              modelValue: _ctx.state.amount,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.amount) = $event))
            }, null, 8, ["disabled", "invalid", "validation-errors", "modelValue"]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_bs_file_zone, {
                modelValue: _ctx.state.file,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.file) = $event)),
                accept: ".jpg, .png, .pdf",
                disabled: _ctx.state.isLoading,
                invalid: _ctx.state_form$.file.$error
              }, null, 8, ["modelValue", "disabled", "invalid"])
            ]),
            _createVNode(_component_bs_textarea, {
              placeholder: "Комментарий (не обязательно)",
              modelValue: _ctx.state.comment,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.comment) = $event)),
              disabled: _ctx.state.isLoading
            }, null, 8, ["modelValue", "disabled"]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_bs_button, {
                size: "big",
                disabled: _ctx.state.isLoading,
                onClick: _ctx.onClose
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Отмена")
                ]),
                _: 1
              }, 8, ["disabled", "onClick"]),
              _createVNode(_component_bs_button, {
                size: "big",
                color: "royal-blue",
                disabled: _ctx.state.isLoading,
                onClick: _ctx.onSubmit
              }, {
                default: _withCtx(() => [
                  _hoisted_10,
                  _createTextVNode(" Подтвердить ")
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["model-value", "onUpdate:modelValue", "onClose"]))
}